import React from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ServerError from '../../../../../components/ServerError';
import CardHeader from '../../../components/CardHeader';
import { useMyTimeTrackingQuery } from '../../../__generated__/graphql';
import Loading from './Loading';
import StartTimeTracking from './StartTimeTracking';
import TimeTracking from './TimeTracking';
import { useTimeTrackingRestriction } from '../../../hooks/timeTrackingSettings';
import { toISODateOnly } from '../../../../../utils/dateUtils';

const Content: React.FC = () => {
  const { t } = useTranslation();

  const { data, loading, error } = useMyTimeTrackingQuery();
  const { getTimeTrackingRestrictedReason } = useTimeTrackingRestriction();

  if (loading) return <Loading />;

  if (error || data === undefined) return <ServerError />;

  const entry = data.me.currentTimeEntry;

  const restrictionReason = getTimeTrackingRestrictedReason(
    toISODateOnly(new Date()),
  );

  if (restrictionReason && !entry) {
    return (
      <p className="text-center">
        {t('timeTracking.current.notEnabled')}
        <br />
        {restrictionReason}
      </p>
    );
  }

  return entry ? <TimeTracking entry={entry} /> : <StartTimeTracking />;
};

const CurrentTimeTracking: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader>{t('timeTracking.current.title')}</CardHeader>
      <Card.Body>
        <Content />
      </Card.Body>
    </Card>
  );
};

export default CurrentTimeTracking;
